import styled, { css } from 'styled-components'

export const FormGroupSelect = styled.div`
	max-width: 100%;
	padding: 6px 10px;
	margin: 0px 24px 0 24px;
`

export const CardLabel = styled.label`
	line-height: 1.2;
	margin: 5px 5px 0 5px;
	font-size: 14px;
	font-family: 'Montserrat', sans-serif;
	font-weight: 500;
	color: #64778f;
`

export const SelectInstallment = styled.select`
	width: 100%;
	display: block;
	border: none;
	background-color: #f5f7fa;
	border-radius: 6px;
	height: 40px;
	color: #64778f;
	font-weight: 500;
	font-size: 16px;
	padding: 0 8px;
	font-family: Montserrat, sans-serif, Arial;
`

export const InstallmentError = styled.label`
	font-family: Montserrat, sans-serif, Arial;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #c22a58;
	margin-left: 4px;
`

export const FormGroupCheckbox = styled.div<{ isIOS: boolean }>`
	max-width: 100%;
	padding: 6px 10px;
	margin: 20px 24px 0 24px;
	label {
		margin-left: 0px;
		font-family: 'Montserrat', sans-serif;

		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 180%;
		display: flex;
		align-items: center;
		color: #64778f;
	}

	${({ isIOS }) =>
		isIOS &&
		css`
			input {
				::after {
					top: 1.3px !important;
					left: 4px !important;
					border-width: 0px 3px 3px 0px !important;
				}
			}
			label {
				padding-left: 15px;
			}
		`}
`

export const Actions = styled.div`
	text-align: center;
	padding: 6px 14px;
`

export const Button = styled.button<{ disabled?: boolean }>`
	width: 100%;
	min-width: 120px;
	padding: 10px 20px;
	background-color: #bbb;
	color: #eee;
	border: none;
	border-radius: 4px;

	${({ disabled }) =>
		!disabled
			? css`
					background-color: #5082c2;
					font-weight: 500;
					font-family: 'Montserrat', sans-serif;
					color: white;
					cursor: pointer;
			  `
			: css`
					background-color: #ddd;
					cursor: not-allowed;
			  `}
`

export const SpinnerButton = styled.div`
	display: flex;
	justify-content: center;
`
